(function () {
  const roots = document.querySelectorAll("[data-shikiwa-customizer]");
  roots.forEach((root) => initCustomizer(root));

  async function initCustomizer(root) {
    const form = root.querySelector("[data-shikiwa-form]");
    const submit = root.querySelector("[data-shikiwa-submit]");
    const error = root.querySelector("[data-shikiwa-error]");
    const variantIdInput = root.querySelector("[data-shikiwa-variant-id]");
    const priceNode = root.querySelector("[data-shikiwa-price]");
    const skuNode = root.querySelector("[data-shikiwa-sku]");
    const summaryNode = root.querySelector("[data-shikiwa-summary]");
    const chainGroup = root.querySelector("[data-shikiwa-chain-group]");
    const operationOptionsNode = root.querySelector("[data-shikiwa-operation-options]");
    const priceCardsNode = root.querySelector("[data-shikiwa-price-cards]");
    const sizeLimitConfirmNode = root.querySelector("[data-shikiwa-size-limit-confirm]");
    const sizeLimitNoteNode = root.querySelector("[data-shikiwa-size-limit-note]");
    const sizeLimitListNode = root.querySelector("[data-shikiwa-size-limit-list]");
    const operationInputName = `shikiwa_operation_${Math.random().toString(36).slice(2)}`;

    const propertyInputs = {
      operation: root.querySelector('[data-shikiwa-property="operation"]'),
      fabricGroup: root.querySelector('[data-shikiwa-property="fabricGroup"]'),
      widthRangeCm: root.querySelector('[data-shikiwa-property="widthRangeCm"]'),
      heightRangeCm: root.querySelector('[data-shikiwa-property="heightRangeCm"]'),
      color: root.querySelector('[data-shikiwa-property="color"]'),
      orderWidthCm: root.querySelector('[data-shikiwa-property="orderWidthCm"]'),
      orderHeightCm: root.querySelector('[data-shikiwa-property="orderHeightCm"]'),
      fabricColorConfirmed: root.querySelector('[data-shikiwa-property="fabricColorConfirmed"]'),
      measurementConfirmed: root.querySelector('[data-shikiwa-property="measurementConfirmed"]'),
      sizeLimitConfirmed: root.querySelector('[data-shikiwa-property="sizeLimitConfirmed"]'),
      chainSide: root.querySelector('[data-shikiwa-property="chainSide"]'),
      chainLength: root.querySelector('[data-shikiwa-property="chainLength"]'),
      note: root.querySelector('[data-shikiwa-property="note"]'),
    };

    const fields = {
      operation: root.querySelectorAll('[data-shikiwa-field="operation"]'),
      fabricGroup: root.querySelector('[data-shikiwa-field="fabricGroup"]'),
      widthRangeCm: root.querySelector('[data-shikiwa-field="widthRangeCm"]'),
      heightRangeCm: root.querySelector('[data-shikiwa-field="heightRangeCm"]'),
    };

    const extras = {
      color: root.querySelector('[data-shikiwa-extra="color"]'),
      orderWidthCm: root.querySelector('[data-shikiwa-extra="orderWidthCm"]'),
      orderHeightCm: root.querySelector('[data-shikiwa-extra="orderHeightCm"]'),
      confirmFabricColor: root.querySelector('[data-shikiwa-extra="confirmFabricColor"]'),
      confirmMeasurement: root.querySelector('[data-shikiwa-extra="confirmMeasurement"]'),
      confirmSizeLimit: root.querySelector('[data-shikiwa-extra="confirmSizeLimit"]'),
      chainSide: root.querySelector('[data-shikiwa-extra="chainSide"]'),
      chainLength: root.querySelector('[data-shikiwa-extra="chainLength"]'),
      note: root.querySelector('[data-shikiwa-extra="note"]'),
    };

    const image = root.querySelector(".shikiwa-product__image");
    root.querySelectorAll("[data-shikiwa-image]").forEach((button) => {
      button.addEventListener("click", () => {
        if (image) {
          image.removeAttribute("srcset");
          image.src = button.dataset.shikiwaImage;
        }
        root.querySelectorAll("[data-shikiwa-image]").forEach((item) => item.classList.remove("is-active"));
        button.classList.add("is-active");
      });
    });
    applyProductImageFallbacks();

    let data;
    let customOptions;
    try {
      const [variantResponse, customResponse] = await Promise.all([
        fetch(root.dataset.mapUrl, { credentials: "same-origin" }),
        fetch(root.dataset.customOptionsUrl, { credentials: "same-origin" }),
      ]);
      if (!variantResponse.ok) throw new Error(`Variant map request failed: ${variantResponse.status}`);
      if (!customResponse.ok) throw new Error(`Custom options request failed: ${customResponse.status}`);
      data = await variantResponse.json();
      customOptions = await customResponse.json();
    } catch (fetchError) {
      showUnavailable(fetchError.message);
      return;
    }

    populateVariantFields(data.options || {});
    refreshFields();
    populateColorOptions(customOptions.colors || []);
    populateSelectFromAsset(extras.chainSide, customOptions.chainSides || []);
    populateSelectFromAsset(extras.chainLength, customOptions.chainLengths || []);
    populateSizeLimitNotes();
    populatePriceCards();
    populateSpec();

    const variants = data.variants || [];
    const formatter = new Intl.NumberFormat("ja-JP", {
      style: "currency",
      currency: data.currency || "JPY",
      maximumFractionDigits: 0,
    });
    let currentValidationMessage = "";

    function refreshFields() {
      fields.operation = root.querySelectorAll('[data-shikiwa-field="operation"]');
      fields.fabricGroup = root.querySelector('[data-shikiwa-field="fabricGroup"]');
      fields.widthRangeCm = root.querySelector('[data-shikiwa-field="widthRangeCm"]');
      fields.heightRangeCm = root.querySelector('[data-shikiwa-field="heightRangeCm"]');
    }

    function populateVariantFields(options) {
      populateOperationOptions(options.operations || []);
      populateSelectOptions(fields.fabricGroup, options.fabricGroups || [], "生地を選択してください");
      populateSelectOptions(fields.widthRangeCm, options.widthRangesCm || [], "幅レンジを選択してください", "cm");
      populateSelectOptions(fields.heightRangeCm, options.heightRangesCm || [], "高さレンジを選択してください", "cm");
    }

    function applyProductImageFallbacks() {
      const mapUrl = root.dataset.mapUrl || "";
      if (!mapUrl.includes("shikiwa-t833-a01-variant-map")) return;

      const detailStack = root.querySelector(".shikiwa-long-images__stack");
      const referenceUrl =
        image?.getAttribute("src") ||
        detailStack?.querySelector("img")?.getAttribute("src") ||
        "";
      const topCleanUrl = assetUrlFrom(referenceUrl, "rakuten-t833-a01-top-clean.jpg");

      if (topCleanUrl && image) {
        image.removeAttribute("srcset");
        image.src = topCleanUrl;
      }

      const heroButton = root.querySelector("[data-shikiwa-image]");
      const heroThumb = heroButton?.querySelector("img");
      if (topCleanUrl && heroButton) {
        heroButton.dataset.shikiwaImage = topCleanUrl;
        heroButton.setAttribute("aria-label", "SHIKIWA roman shade product image");
      }
      if (topCleanUrl && heroThumb) {
        heroThumb.removeAttribute("srcset");
        heroThumb.src = topCleanUrl;
      }

      const t833LongAssets = [
        "rakuten-t833-a01-long-01.jpg",
        "rakuten-t833-a01-long-02.jpg",
        "rakuten-t833-a01-long-03.jpg",
        "rakuten-t833-a01-long-04.jpg",
        "rakuten-t833-a01-long-05.gif",
        "rakuten-t833-a01-long-06.jpg",
        "rakuten-t833-a01-long-07.gif",
        "rakuten-t833-a01-long-08.jpg",
        "rakuten-t833-a01-long-09.gif",
        "rakuten-t833-a01-long-10.jpg",
        "rakuten-t833-a01-long-11.gif",
        "rakuten-t833-a01-long-12.jpg",
        "rakuten-t833-a01-long-13.gif",
        "rakuten-t833-a01-long-14.jpg",
      ];
      const hasLong01 =
        detailStack &&
        [...detailStack.querySelectorAll("img")].some((img) => img.src.includes("rakuten-t833-a01-long-01.jpg"));
      if (detailStack && referenceUrl && !hasLong01) {
        [...t833LongAssets].reverse().forEach((assetName, index) => {
          const detailUrl = assetUrlFrom(referenceUrl, assetName);
          if (!detailUrl) return;
          const detailImage = document.createElement("img");
          detailImage.src = detailUrl;
          detailImage.alt = `SHIKIWA roman shade detail ${t833LongAssets.length - index}`;
          detailImage.loading = "lazy";
          detailStack.prepend(detailImage);
        });
      }
    }

    function assetUrlFrom(referenceUrl, assetName) {
      if (!referenceUrl) return "";
      const cleanReference = referenceUrl.split("?")[0];
      const lastSlash = cleanReference.lastIndexOf("/");
      if (lastSlash === -1) return "";
      return `${cleanReference.slice(0, lastSlash + 1)}${assetName}`;
    }

    function populateOperationOptions(values) {
      if (!operationOptionsNode || values.length === 0) return;
      operationOptionsNode.innerHTML = "";
      const help = customOptions.operationHelp || {};
      values.forEach((value, index) => {
        const label = document.createElement("label");
        const input = document.createElement("input");
        input.type = "radio";
        input.name = operationInputName;
        input.value = value;
        input.dataset.shikiwaField = "operation";
        input.checked = index === 0;

        const span = document.createElement("span");
        const strong = document.createElement("strong");
        strong.textContent = value;
        span.appendChild(strong);
        if (help[value]) {
          const small = document.createElement("small");
          small.textContent = help[value];
          span.appendChild(small);
        }
        label.appendChild(input);
        label.appendChild(span);
        operationOptionsNode.appendChild(label);
      });
    }

    function populateSelectOptions(select, values, placeholderText, suffix = "") {
      if (!select || values.length === 0) return;
      const currentValue = select.value;
      select.innerHTML = "";
      const placeholder = document.createElement("option");
      placeholder.value = "";
      placeholder.textContent = placeholderText;
      placeholder.disabled = true;
      select.appendChild(placeholder);
      values.forEach((value) => {
        const option = document.createElement("option");
        option.value = value;
        option.textContent = suffix ? `${value}${suffix}` : value;
        select.appendChild(option);
      });
      select.value = values.includes(currentValue) ? currentValue : values[0];
    }

    function populateColorOptions(colors) {
      if (!extras.color) return;
      extras.color.innerHTML = "";
      const placeholder = document.createElement("option");
      placeholder.value = "";
      placeholder.textContent = "カラーを選択してください";
      extras.color.appendChild(placeholder);

      colors.forEach((color, index) => {
        const option = document.createElement("option");
        option.textContent = color.label;
        option.value = color.isGroup ? `__group_${index}` : color.value;
        option.disabled = Boolean(color.isGroup);
        option.dataset.group = color.isGroup ? "true" : "false";
        extras.color.appendChild(option);
      });
    }

    function populateSelectFromAsset(select, values) {
      if (!select || values.length === 0) return;
      const currentValue = select.value;
      select.innerHTML = "";
      values.forEach((value) => {
        const option = document.createElement("option");
        option.value = value;
        option.textContent = value;
        select.appendChild(option);
      });
      if (values.includes(currentValue)) {
        select.value = currentValue;
      }
    }

    function populateSizeLimitNotes() {
      const rules = getSizeLimitRules();
      if (!sizeLimitListNode || rules.length === 0) return;
      sizeLimitListNode.innerHTML = "";
      rules.forEach((rule) => {
        const note = rule.note || rule.message;
        if (!note) return;
        const item = document.createElement("li");
        item.textContent = note;
        sizeLimitListNode.appendChild(item);
      });
    }

    function populatePriceCards() {
      if (!priceCardsNode) return;
      const groups = new Map();
      variants.forEach((variant) => {
        const key = variant.combinedOption || `${variant.operation} / ${variant.fabricGroup}`;
        if (!groups.has(key)) groups.set(key, []);
        groups.get(key).push(variant.priceJpyTaxIncluded);
      });
      priceCardsNode.innerHTML = "";
      groups.forEach((prices, key) => {
        const article = document.createElement("article");
        const title = document.createElement("h3");
        const price = document.createElement("p");
        title.textContent = key.replace("｜", " / ");
        price.textContent = `${formatter.format(Math.min(...prices))}〜${formatter.format(Math.max(...prices))}`;
        article.appendChild(title);
        article.appendChild(price);
        priceCardsNode.appendChild(article);
      });
    }

    function populateSpec() {
      const setText = (key, value) => {
        const node = root.querySelector(`[data-shikiwa-spec="${key}"]`);
        if (node) node.textContent = value;
      };
      const options = data.options || {};
      setText("operations", (options.operations || []).join(" / "));
      setText("fabricGroups", (options.fabricGroups || []).join(" / "));
      setText("widthRanges", rangeText(options.widthRangesCm || []));
      setText("heightRanges", rangeText(options.heightRangesCm || []));
    }

    function rangeText(values) {
      if (values.length === 0) return "-";
      const mins = values.map((value) => Number.parseFloat(value.split("-")[0])).filter(Number.isFinite);
      const maxes = values.map((value) => Number.parseFloat(value.split("-")[1])).filter(Number.isFinite);
      if (mins.length === 0 || maxes.length === 0) return values.join(" / ");
      return `${Math.min(...mins)}cm〜${Math.max(...maxes)}cm のレンジから選択`;
    }

    function selectedOperation() {
      return [...fields.operation].find((input) => input.checked)?.value || "";
    }

    function selectedValues() {
      return {
        operation: selectedOperation(),
        fabricGroup: fields.fabricGroup?.value || "",
        widthRangeCm: fields.widthRangeCm?.value || "",
        heightRangeCm: fields.heightRangeCm?.value || "",
      };
    }

    function selectedExtras(values) {
      const chainRequired = isChainRequired(values);
      const hasChainSideOptions = hasOptions(customOptions.chainSides);
      const hasChainLengthOptions = hasOptions(customOptions.chainLengths);
      return {
        color: extras.color?.value || "",
        orderWidthCm: parseNumber(extras.orderWidthCm?.value),
        orderHeightCm: parseNumber(extras.orderHeightCm?.value),
        confirmFabricColor: Boolean(extras.confirmFabricColor?.checked),
        confirmMeasurement: Boolean(extras.confirmMeasurement?.checked),
        confirmSizeLimit: !requiresSizeLimitConfirmation() || Boolean(extras.confirmSizeLimit?.checked),
        chainSide: chainRequired && hasChainSideOptions ? extras.chainSide?.value || "" : "",
        chainLength: chainRequired && hasChainLengthOptions ? extras.chainLength?.value || "" : "",
        note: extras.note?.value.trim() || "",
      };
    }

    function parseNumber(value) {
      if (value === undefined || value === null || String(value).trim() === "") return null;
      const parsed = Number.parseFloat(String(value));
      return Number.isFinite(parsed) ? parsed : null;
    }

    function parseRange(range) {
      const match = /^(\d+)-(\d+)$/.exec(range);
      if (!match) return null;
      return {
        min: Number.parseInt(match[1], 10),
        max: Number.parseInt(match[2], 10),
      };
    }

    function inRange(value, range) {
      if (value === null || !range) return false;
      return value >= range.min && value <= range.max;
    }

    function hasOptions(values) {
      return Array.isArray(values) && values.length > 0;
    }

    function isChainRequired(values) {
      const mode = customOptions.chainMode || "operation";
      if (mode === "always") return hasOptions(customOptions.chainSides) || hasOptions(customOptions.chainLengths);
      if (mode === "never") return false;
      const chainOperations = customOptions.chainOperations || ["チェーン式"];
      return chainOperations.includes(values.operation);
    }

    function requiresSizeLimitConfirmation() {
      return customOptions.requireSizeLimitConfirmation !== false;
    }

    function getSizeLimitRules() {
      if (Array.isArray(customOptions.sizeLimitRules)) {
        return customOptions.sizeLimitRules;
      }
      return [
        {
          operations: ["コードレス式"],
          minWidthCm: 57,
          message: "コードレス式は幅57cm以上で指定してください。",
          note: "コードレス式：幅57cm以上で指定してください。",
        },
        {
          operations: ["コードレス式"],
          maxHeightCm: 240,
          message: "コードレス式は高さ240cm以下で指定してください。",
          note: "コードレス式の高さは240cm以下です。",
        },
        {
          operations: ["コードレス式"],
          when: { heightGreaterThanCm: 150 },
          minWidthCm: 65,
          message: "コードレス式で高さ150cm超の場合は幅65cm以上で指定してください。",
          note: "コードレス式で高さ150cm超の場合は、幅65cm以上で指定してください。",
        },
        {
          operations: ["チェーン式"],
          note: "チェーン式は、選択できるサイズレンジ内で追加制限はありません。",
        },
      ];
    }

    function findVariant(values) {
      return variants.find((variant) => {
        return (
          variant.operation === values.operation &&
          variant.fabricGroup === values.fabricGroup &&
          variant.widthRangeCm === values.widthRangeCm &&
          variant.heightRangeCm === values.heightRangeCm
        );
      });
    }

    function syncDimensionAttributes(values) {
      const widthRange = parseRange(values.widthRangeCm);
      const heightRange = parseRange(values.heightRangeCm);
      if (extras.orderWidthCm && widthRange) {
        extras.orderWidthCm.min = String(widthRange.min);
        extras.orderWidthCm.max = String(widthRange.max);
        extras.orderWidthCm.placeholder = `${widthRange.min}-${widthRange.max}`;
      }
      if (extras.orderHeightCm && heightRange) {
        extras.orderHeightCm.min = String(heightRange.min);
        extras.orderHeightCm.max = String(heightRange.max);
        extras.orderHeightCm.placeholder = `${heightRange.min}-${heightRange.max}`;
      }
    }

    function syncChainVisibility(values) {
      const chainRequired = isChainRequired(values);
      const hasChainSideOptions = hasOptions(customOptions.chainSides);
      const hasChainLengthOptions = hasOptions(customOptions.chainLengths);
      const showGroup = chainRequired && (hasChainSideOptions || hasChainLengthOptions);
      if (chainGroup) chainGroup.hidden = !showGroup;

      setFieldVisibility(extras.chainSide, chainRequired && hasChainSideOptions);
      setFieldVisibility(extras.chainLength, chainRequired && hasChainLengthOptions);
    }

    function syncSizeLimitVisibility() {
      const required = requiresSizeLimitConfirmation();
      if (sizeLimitConfirmNode) sizeLimitConfirmNode.hidden = !required;
      if (sizeLimitNoteNode) sizeLimitNoteNode.hidden = !required || getSizeLimitRules().length === 0;
      if (extras.confirmSizeLimit) {
        extras.confirmSizeLimit.disabled = !required;
        if (!required) extras.confirmSizeLimit.checked = false;
      }
    }

    function setFieldVisibility(field, visible) {
      if (!field) return;
      const wrapper = field.closest(".shikiwa-customizer__field");
      if (wrapper) wrapper.hidden = !visible;
      field.disabled = !visible;
    }

    function validateCustomValues(values, custom) {
      const widthRange = parseRange(values.widthRangeCm);
      const heightRange = parseRange(values.heightRangeCm);

      if (!custom.color || custom.color.startsWith("__group_")) {
        return "カラーを選択してください。";
      }
      if (!custom.confirmFabricColor) {
        return "商品生地とカラーの確認にチェックしてください。";
      }
      if (!custom.confirmMeasurement) {
        return "採寸方法の確認にチェックしてください。";
      }
      if (requiresSizeLimitConfirmation() && !custom.confirmSizeLimit) {
        return "サイズ制限の確認にチェックしてください。";
      }
      if (custom.orderWidthCm === null) {
        return "幅(cm)を入力してください。";
      }
      if (custom.orderHeightCm === null) {
        return "高さ(cm)を入力してください。";
      }
      if (!inRange(custom.orderWidthCm, widthRange)) {
        return `幅は選択中の${values.widthRangeCm}cmの範囲内で入力してください。`;
      }
      if (!inRange(custom.orderHeightCm, heightRange)) {
        return `高さは選択中の${values.heightRangeCm}cmの範囲内で入力してください。`;
      }

      const sizeLimitMessage = validateSizeLimitRules(values, custom);
      if (sizeLimitMessage) return sizeLimitMessage;

      if (isChainRequired(values) && hasOptions(customOptions.chainSides) && !custom.chainSide) {
        return "チェーン操作位置を選択してください。";
      }
      if (isChainRequired(values) && hasOptions(customOptions.chainLengths) && !custom.chainLength) {
        return "チェーン長さを選択してください。";
      }
      if (customOptions.noteRequired && !custom.note) {
        return "その他希望を入力してください。特になければ「なし」と入力してください。";
      }

      return "";
    }

    function validateSizeLimitRules(values, custom) {
      if (!requiresSizeLimitConfirmation() && getSizeLimitRules().length === 0) return "";
      for (const rule of getSizeLimitRules()) {
        if (Array.isArray(rule.operations) && rule.operations.length > 0 && !rule.operations.includes(values.operation)) {
          continue;
        }
        if (rule.when?.heightGreaterThanCm !== undefined && !(custom.orderHeightCm > rule.when.heightGreaterThanCm)) {
          continue;
        }
        if (rule.when?.heightLessThanCm !== undefined && !(custom.orderHeightCm < rule.when.heightLessThanCm)) {
          continue;
        }
        if (rule.when?.widthGreaterThanCm !== undefined && !(custom.orderWidthCm > rule.when.widthGreaterThanCm)) {
          continue;
        }
        if (rule.when?.widthLessThanCm !== undefined && !(custom.orderWidthCm < rule.when.widthLessThanCm)) {
          continue;
        }
        if (rule.minWidthCm !== undefined && custom.orderWidthCm < rule.minWidthCm) {
          return rule.message || `幅は${rule.minWidthCm}cm以上で指定してください。`;
        }
        if (rule.maxWidthCm !== undefined && custom.orderWidthCm > rule.maxWidthCm) {
          return rule.message || `幅は${rule.maxWidthCm}cm以下で指定してください。`;
        }
        if (rule.minHeightCm !== undefined && custom.orderHeightCm < rule.minHeightCm) {
          return rule.message || `高さは${rule.minHeightCm}cm以上で指定してください。`;
        }
        if (rule.maxHeightCm !== undefined && custom.orderHeightCm > rule.maxHeightCm) {
          return rule.message || `高さは${rule.maxHeightCm}cm以下で指定してください。`;
        }
      }
      return "";
    }

    function setPropertyInput(key, value) {
      if (propertyInputs[key]) propertyInputs[key].value = value || "";
    }

    function setPropertyInputs(values, custom) {
      setPropertyInput("operation", values.operation);
      setPropertyInput("fabricGroup", values.fabricGroup);
      setPropertyInput("widthRangeCm", values.widthRangeCm);
      setPropertyInput("heightRangeCm", values.heightRangeCm);
      setPropertyInput("color", custom.color);
      setPropertyInput("orderWidthCm", custom.orderWidthCm === null ? "" : `${custom.orderWidthCm}cm`);
      setPropertyInput("orderHeightCm", custom.orderHeightCm === null ? "" : `${custom.orderHeightCm}cm`);
      setPropertyInput("fabricColorConfirmed", custom.confirmFabricColor ? "確認しました。" : "");
      setPropertyInput("measurementConfirmed", custom.confirmMeasurement ? "確認しました。" : "");
      setPropertyInput("sizeLimitConfirmed", requiresSizeLimitConfirmation() && custom.confirmSizeLimit ? "確認しました。" : "");
      setPropertyInput("chainSide", custom.chainSide);
      setPropertyInput("chainLength", custom.chainLength);
      setPropertyInput("note", custom.note);
    }

    function showUnavailable(message) {
      currentValidationMessage = message || "この組み合わせの価格が見つかりません。";
      if (variantIdInput) variantIdInput.value = "";
      if (priceNode) priceNode.textContent = "-";
      if (skuNode) skuNode.textContent = "-";
      if (summaryNode) summaryNode.textContent = "-";
      if (submit) submit.disabled = true;
      if (error) {
        error.textContent = currentValidationMessage;
        error.hidden = false;
      }
    }

    function showValidation(message) {
      currentValidationMessage = message;
      if (submit) submit.disabled = Boolean(message);
      if (error) {
        error.textContent = message;
        error.hidden = !message;
      }
    }

    function update() {
      const values = selectedValues();
      syncDimensionAttributes(values);
      syncChainVisibility(values);
      syncSizeLimitVisibility();
      const custom = selectedExtras(values);
      const variant = findVariant(values);
      setPropertyInputs(values, custom);

      if (!variant) {
        showUnavailable("この組み合わせの価格が見つかりません。");
        return;
      }

      if (variantIdInput) variantIdInput.value = variant.numericId;
      if (priceNode) priceNode.textContent = formatter.format(variant.priceJpyTaxIncluded);
      if (skuNode) skuNode.textContent = variant.sku;
      if (summaryNode) {
        const sizeText =
          custom.orderWidthCm === null || custom.orderHeightCm === null
            ? `幅 ${values.widthRangeCm} / 高さ ${values.heightRangeCm}`
            : `幅 ${custom.orderWidthCm}cm / 高さ ${custom.orderHeightCm}cm`;
        summaryNode.textContent = `${values.operation} / ${values.fabricGroup} / ${sizeText}`;
      }

      showValidation(validateCustomValues(values, custom));

      const nextUrl = new URL(window.location.href);
      nextUrl.searchParams.set("variant", variant.numericId);
      window.history.replaceState({}, "", nextUrl.toString());
    }

    Object.values(fields).forEach((field) => {
      if (field instanceof NodeList) {
        field.forEach((input) => input.addEventListener("change", update));
      } else if (field) {
        field.addEventListener("change", update);
      }
    });

    Object.values(extras).forEach((field) => {
      if (field) {
        field.addEventListener("change", update);
        field.addEventListener("input", update);
      }
    });

    form.addEventListener("submit", (event) => {
      update();
      if (!variantIdInput.value || currentValidationMessage) {
        event.preventDefault();
        if (!currentValidationMessage) {
          showUnavailable("この組み合わせの価格が見つかりません。");
        }
      }
    });

    update();
  }
})();
